import { inject, injectable } from '@wix/typesafe-inversify';
import type { EditorSDK } from '@wix/platform-editor-sdk';
import type { IEditorTransactions } from './IEditorTransactions';
import { Services } from '../../ioc/services';

@injectable()
export class EditorTransactions implements IEditorTransactions {
  constructor(@inject(Services.EditorSDK) private editorSDK: EditorSDK) {}

  runAndWaitForApproval<T>(action: () => Promise<T>): Promise<T> {
    return this.editorSDK.document.transactions.runAndWaitForApproval(
      'token',
      action,
    );
  }
}
